// assets/mega-hover.js
document.addEventListener('DOMContentLoaded', () => {
  // 仅桌面端启用；如需强制测试，把下一行改为 `true`
  const isDesktopHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (!isDesktopHover) return;

  const menuRoot =
    document.querySelector('.header__inline-menu') ||
    document.querySelector('header, .shopify-section-header');
  if (!menuRoot) {
    console.warn('[mega-hover] menuRoot not found');
    return;
  }

  // 你的结构：<header-menu><details class="mega-menu">…</details></header-menu>
  const menus = menuRoot.querySelectorAll('header-menu details.mega-menu, details.mega-menu');
  console.debug('[mega-hover] found menus:', menus.length);
  const timers = new WeakMap();

  // 只展开一个
  const open = (details, summary) => {
    clearTimeout(timers.get(details));
    menus.forEach((d) => d !== details && d.removeAttribute('open'));
    details.setAttribute('open', '');
    if (summary) summary.setAttribute('aria-expanded', 'true');
  };
  const close = (details, summary, delay = 120) => {
    clearTimeout(timers.get(details));
    const t = setTimeout(() => {
      details.removeAttribute('open');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    }, delay);
    timers.set(details, t);
  };

  menus.forEach((details) => {
    const summary =
      details.querySelector('summary.header__menu-item, summary') || details.querySelector('summary');
    // 重点：你的面板是 div.mega-menu__content（不是 ul）
    const panel =
      details.querySelector('.mega-menu__content') ||
      (summary?.id && document.getElementById(summary.getAttribute('aria-controls')));
    if (!summary || !panel) {
      console.warn('[mega-hover] skip one: summary/panel missing', details);
      return;
    }

    // 用 pointerenter/leave 更稳（避免 mouseover 穿透子元素频繁触发）
    summary.addEventListener('pointerenter', () => open(details, summary));
    panel.addEventListener('pointerenter', () => open(details, summary));
    details.addEventListener('pointerleave', () => close(details, summary, 120));

    // 键盘可达 & Esc 关闭
    details.addEventListener('focusin', () => open(details, summary));
    details.addEventListener('focusout', (e) => {
      if (!details.contains(e.relatedTarget)) close(details, summary, 80);
    });
    details.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        details.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
        summary.focus();
      }
    });

    // 阻止桌面端点击 summary 触发默认切换（保持“纯悬停”）
    summary.addEventListener('click', (e) => e.preventDefault());
  });

  // 点击 header 外区域，全部收起
  document.addEventListener('pointerdown', (e) => {
    const header = document.querySelector('header, .shopify-section-header');
    if (header && !header.contains(e.target)) menus.forEach((d) => d.removeAttribute('open'));
  });

  console.debug('[mega-hover] initialized');
});
